import React from 'react';
import { getSectionClassNames } from '~/utilities/component-color';
import AnimationPlayer from '../../shared/animationPlayer/AnimationPlayer';

const AnimationComponent = ({ animation, componentBackgroundColor }) => (
  <section className={getSectionClassNames(componentBackgroundColor)}>
    <div className="container-fluid">
      <div className="section-gutter">
        <div className="section-animation">
          <AnimationPlayer {...animation} />
        </div>
      </div>
    </div>
  </section>
);

export default AnimationComponent;
